"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.addressMetaToAddress = void 0;
var constants_1 = require("./constants");
var addressMetaToAddress = function (meta, country) {
    if (country === constants_1.Country.AU) {
        return {
            line1: meta.address_line_1,
            line2: meta.address_line_2,
            suburb: meta.locality_name,
            state: meta.state_territory,
            postcode: meta.postcode,
            country: country,
        };
    }
    return {
        line1: meta.address_line_1,
        line2: meta.address_line_2,
        suburb: meta.suburb,
        city: meta.city,
        postcode: meta.postcode,
        country: country,
    };
};
exports.addressMetaToAddress = addressMetaToAddress;
//# sourceMappingURL=helpers.js.map